import {palette} from "../common";

export default {
    styleOverrides: {
        tooltip: {
            backgroundColor: palette.primary.main,

            fontSize: 14,
            lineHeight: '18px'
        },
        arrow: {
            color: palette.primary.main
        }
    }
}
